import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import ImageUpdateLoader from '@/shared-components/loader/special-loaders/ImageUpdateLoader';

import ArtworkImage from './ArtworkImage';

import './styles/ArtlistImage.css';

export default function ArtlistImage({ image, loading = false, className = "", style = {}, artworkData, alt }) {
  if (loading) {
    return (
      <div className={`artlist-image-loading-generic ${className}`} style={style}>
        <ImageUpdateLoader />
      </div>
    );
  }
  else if (!image) {
    // Show a placeholder icon if no image is provided
    return (
      <div className={`artlist-image__artlist-image-template ${className}`} style={style}>
        <ArtlistIcon className="artlist-image__artlist-icon" />
      </div>
    );
  } else {
    // Show the actual image
    return (
      <div className={`artlist-image__artlist-image-container ${className}`}>
        <div className="artlist-image__artlist-overlay">
          <ArtworkImage
            image={image}
            imageTemplateClassName="artlist-image__artlist-image"
            imageClassName="artlist-image__artlist-image"
            forceSmaller={300}
            artworkData={artworkData}
            alt={alt}
            enabledDoubleClick={false}
          />
        </div>
      </div>
    );
  }
}
